import React from 'react';
import css from './css.module.less';

const Container = (props) => {
  const { top, bottom, offset = 0 } = props;
  return (
    <div className={css.container}>
      <div className={css.top}>{top}</div>
      <div className={css.divider} />
      <div
        className={css.bottom}
        style={{ maxHeight: `calc(100vh - ${offset}px)` }}>
        {bottom}
      </div>
    </div>
  );
};
export default Container;
